import React, {useEffect} from 'react';

import {useDispatch, batch} from 'react-redux';

import {showAlert} from '@/actions/debugActions';
import {showLoading, updateLoading} from '@/actions/loadingActions';
import * as setupActions from '@/actions/setupActions';
import {PostRequest} from '@/api/request';
import {POST_DISCONNECT_FROM_WIFI} from '@/constants/apis';
import {ALERT_TYPE} from '@/constants/enums';
import {SYSTEM_SETTING as SYSTEM_SETTING_MESSAGE} from '@/constants/messages';
import {
  TURN_ON,
  TURN_OFF,
  DISCONNECT,
  BACK,
  CALIBRATION_LOAD_CELL_SENSOR_ADDRESS,
  SYSTEM_SETTING,
  WIFI_STATUS,
  DISCONNECT_LOADING,
} from '@/constants/pcConstAppData';
import {useWifiStatusContext} from '@/contexts/WifiStatusContext';

// TODO need to refactor into pure component, currently caused by the generated type of component it make difficult to control the flow behavior
const WifiSettingTopMenu = React.memo(() => {
  const dispatch = useDispatch();
  const {wifiStatus, ChangeWifiPower, ChangeWifiStatus} = useWifiStatusContext();

  useEffect(() => {
    setupTopMenuProperties(false, wifiStatus);
  }, [wifiStatus]);

  const setupTopMenuProperties = (disableButton, currentWifiStatus) => {
    const turnOnButtonProperties = {
      id: TURN_ON,
      label: TURN_ON.toUpperCase(),
      onClick: () => {
        ChangeWifiPower(true);
      },
      disabled: disableButton,
      className: ' turnOn-button ',
    };
    const turnOffButtonProperties = {
      id: TURN_OFF,
      label: TURN_OFF.toUpperCase(),
      onClick: () => {
        ChangeWifiPower(false);
      },
      disabled: disableButton,
      className: ' turnOff-button ',
    };
    const disconnectButtonProperties = {
      id: DISCONNECT,
      label: DISCONNECT.toUpperCase(),
      onClick: () => {
        dispatch(
          updateLoading({
            showLoading: true,
            loadingText: DISCONNECT_LOADING,
          }),
        );
        PostRequest(POST_DISCONNECT_FROM_WIFI).then((response) => {
          if (!response.data)
            dispatch(
              showAlert({
                alertShow: true,
                alertText: SYSTEM_SETTING_MESSAGE.WIFI.ALLERT.PASSWORD_INCORRECT,
                alertStyle: ALERT_TYPE.ALERT_DANGER,
              }),
            );
          setupTopMenuProperties(false, WIFI_STATUS.ON);
          ChangeWifiStatus(WIFI_STATUS.ON);
          dispatch(showLoading(false));
        });
      },
      disabled: disableButton,
    };
    const backButtonProperties = {
      id: BACK,
      label: '',
      disabled: false,
      onClick: () => {
        window.location.href = CALIBRATION_LOAD_CELL_SENSOR_ADDRESS;
      },
    };
    const titleMenuProperties = SYSTEM_SETTING;
    if (currentWifiStatus === WIFI_STATUS.CONNECTED)
      setDoubleTopMenuProperties(
        disconnectButtonProperties,
        turnOffButtonProperties,
        backButtonProperties,
        titleMenuProperties,
      );
    else if (currentWifiStatus === WIFI_STATUS.ON)
      setTopMenuProperties(turnOffButtonProperties, backButtonProperties, titleMenuProperties);
    else if (currentWifiStatus === WIFI_STATUS.OFF)
      setTopMenuProperties(turnOnButtonProperties, backButtonProperties, titleMenuProperties);
  };

  const setTopMenuProperties = (topButtonProperties, backButtonProperties, titleMenuProperties) => {
    batch(() => {
      dispatch(
        setupActions.setTopMenuProperties({
          topButtonProperties:
            topButtonProperties === undefined
              ? undefined
              : {
                  id: topButtonProperties.id,
                  label: topButtonProperties.label,
                  disabled: topButtonProperties.disabled,
                  onClick: topButtonProperties.onClick,
                  className: topButtonProperties.className,
                },
          backButtonProperties:
            backButtonProperties === undefined
              ? undefined
              : {
                  id: backButtonProperties.id,
                  label: backButtonProperties.label,
                  disabled: backButtonProperties.disabled,
                  onClick: backButtonProperties.onClick,
                },
          titleMenuProperties,
        }),
      );
      dispatch(setupActions.topButtonTertiaryProperties(undefined));
    });
  };

  const setDoubleTopMenuProperties = (
    button1Properties,
    button2Properties,
    backButtonProperties,
    titleMenuProperties,
  ) => {
    batch(() => {
      dispatch(
        setupActions.setDoubleTopMenuProperties({
          button1Properties:
            button1Properties === undefined
              ? undefined
              : {
                  id: button1Properties.id,
                  label: button1Properties.label,
                  onClick: button1Properties.onClick,
                  disabled: button1Properties.disabled,
                  className: button1Properties.className,
                },
          button2Properties:
            button2Properties === undefined
              ? undefined
              : {
                  id: button2Properties.id,
                  label: button2Properties.label,
                  onClick: button2Properties.onClick,
                  disabled: button2Properties.disabled,
                  className: button2Properties.className,
                },
          backButtonProperties: {
            id: backButtonProperties.id,
            label: '',
            disabled: backButtonProperties.disabled,
            onClick: backButtonProperties.onClick,
          },
          titleMenuProperties,
        }),
      );
      dispatch(setupActions.topButtonTertiaryProperties(undefined));
    });
  };

  return null;
});
export default WifiSettingTopMenu;
